import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  userRole = signal<string>('');
  sidebarVisible = signal(false);
  fromReel = false;
}
